import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './../../../../../../assets/icons/person.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-2d4c53f7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cm-ui-dialog-title" }
const _hoisted_2 = { class: "bind-wrap" }
const _hoisted_3 = { class: "code-row" }
const _hoisted_4 = { class: "cm-ui-txt-rgt" }
const _hoisted_5 = { class: "cm-ui-dialog-title" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-warning" }, null, -1))
const _hoisted_7 = {
  key: 2,
  class: "user-info"
}
const _hoisted_8 = { class: "cm-ui-dialog-title" }
const _hoisted_9 = { class: "id-head cm-ui-rise-in cm-ui-rise-in--d1" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "id-head__avatar" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_11 = { class: "id-head__meta" }
const _hoisted_12 = { class: "id-head__name-line" }
const _hoisted_13 = ["title"]
const _hoisted_14 = ["aria-label"]
const _hoisted_15 = {
  key: 0,
  class: "id-head__chip"
}
const _hoisted_16 = { class: "id-strip cm-ui-rise-in cm-ui-rise-in--d2" }
const _hoisted_17 = { class: "row-label" }
const _hoisted_18 = { class: "info-list" }
const _hoisted_19 = {
  key: 0,
  class: "form-row cm-ui-rise-in cm-ui-rise-in--d3"
}
const _hoisted_20 = { class: "row-label" }
const _hoisted_21 = { class: "row-value" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = {
  key: 1,
  class: "form-row cm-ui-rise-in cm-ui-rise-in--d3"
}
const _hoisted_24 = { class: "row-label" }
const _hoisted_25 = { class: "row-value" }
const _hoisted_26 = {
  key: 2,
  class: "form-row cm-ui-rise-in cm-ui-rise-in--d4"
}
const _hoisted_27 = { class: "row-label" }
const _hoisted_28 = { class: "row-value" }
const _hoisted_29 = { class: "form-row cm-ui-rise-in cm-ui-rise-in--d5" }
const _hoisted_30 = { class: "row-label" }
const _hoisted_31 = { class: "row-value" }

import { computed, nextTick, reactive, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { ElMessage } from 'element-plus'
import { User, UserInfo } from '@/services/user'

import { ACTIVE_NAME_MAP, UserInfoEditService, UserItem } from './user-info-edit.service'
import { interval, merge, of } from 'rxjs'
import { map, take } from 'rxjs/operators'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { defaultErrorAction, errorKeyMap } from '@/common/error/error-code'
import DeleteUser from '@/views/dashboard/_components/central-control/_components/delete-user/delete-user.vue'
import UpdatePassword from '@/views/dashboard/_components/update-password/update-password.vue'
import Copy from '@/views/_components/copy/copy.vue'
const COUNTDOWN_CACHE_KEY = 'user_info_code_countdown'
const COUNT_DOWN_DEFAULT_SECOND = 60
const USER_NAME_MAX_LENGTH = 20


export default /*#__PURE__*/_defineComponent({
  __name: 'user-info-edit',
  setup(__props) {

const { t, locale } = useI18n()
const injector = useReflectiveInjector([UserInfoEditService])
const user = injector.get(User)
const userInfoEditService = injector.get(UserInfoEditService)

const userInfo = reactive<Partial<UserInfo>>({})
const userInfoSpec = reactive<Partial<UserItem>>({})

const activeName = ref<string>(ACTIVE_NAME_MAP.default)
const nameEditRefNode = ref<HTMLInputElement | null>(null)
const nameIsEdit = ref<boolean>(false)
const deleteUserVisible = ref<boolean>(false)
const updatePasswordVisible = ref<boolean>(false)

const tempForm = reactive({
  phone: '',
  code: ''
})
const tempFormRef = ref<HTMLFormElement | null>(null)

const verifyCodeText = ref<string>(t('login.getVerifyCode'))
const canPullVerifyCode = ref<boolean>(false)

const accountTypeLabel = computed(() => {
  void locale.value
  if (userInfoSpec.is_bind_wx) return t('userInfoEdit.typeWechat')
  if (userInfoSpec.is_bind_qq) return t('userInfoEdit.typeQQ')
  if (userInfoSpec.is_bind_mobile) return t('userInfoEdit.typeMobile')
  if (userInfoSpec.is_account_user) return t('userInfoEdit.typeAccountPassword')
  return ''
})

const maskedMobile = computed(() => userInfoSpec.mobile?.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2') || '')

function checkPullVerifyCodeState () {
  tempFormRef.value?.validateField('phone', (_: any, b: any) => {
    canPullVerifyCode.value = !b
  })
}

function countdown (maxCount: number) {
  if (maxCount <= 0) {
    return
  }

  // eslint-disable-next-line no-magic-numbers
  merge(of(-1), interval(1000).pipe(take(maxCount))).pipe(map(i => i + 1)).subscribe(n => {
    const count = maxCount - n
    if (count > 0) {
      canPullVerifyCode.value = false
      verifyCodeText.value = t('login.verifyCodeCountdown', { n: count })
    } else {
      verifyCodeText.value = t('login.getVerifyCode')
      checkPullVerifyCodeState()
    }
  })
}

function recoveryCountdown () {
  let countDownSecond = COUNT_DOWN_DEFAULT_SECOND
  // 获取上次缓存时间
  const cacheTimestamp = Number(localStorage.getItem(COUNTDOWN_CACHE_KEY))
  if (cacheTimestamp) {
    // eslint-disable-next-line no-magic-numbers
    const leftTime = parseInt(((Date.now() - cacheTimestamp) / 1000).toString(), 10)
    if (leftTime < countDownSecond && leftTime > 0) {
      countDownSecond = countDownSecond - leftTime
      countdown(countDownSecond)
    }
  }
}

async function bindPhone () {
  try {
    await tempFormRef.value.validate()
    userInfoEditService.bindPhone({
      login_type: 4,
      mobile: {
        phone: tempForm.phone,
        code: tempForm.code
      }
    }).then(res => {
      Object.assign(userInfoSpec, res.user_info)
      activeName.value = ACTIVE_NAME_MAP.default
      tempForm.code = ''
    })
  } catch (error) {
  }
}

function fetchUserInfo () {
  userInfoEditService.getUserInfo().then(res => {
    Object.assign(userInfoSpec, res.user_info)
    tempForm.phone = userInfoSpec.mobile
    userInfo.nick = userInfoSpec.nick
    user.updateUserinfo(userInfo as UserInfo)
  })
}

user.userInfo.subscribe(info => {
  Object.assign(userInfo, info)
})

fetchUserInfo()

const rules = computed(() => {
  void locale.value
  return {
    phone: [
      {
        required: true,
        min: 11,
        max: 11,
        message: t('login.phoneRule'),
        trigger: ['blur', 'change']
      }
    ],
    code: [
      {
        required: true,
        message: t('login.codeRule'),
        trigger: ['blur', 'change']
      }
    ]
  }
})

function getVerifyCode () {
  userInfoEditService.getVerifyCode(tempForm.phone).then(() => {
    // 缓存倒计时时间
    localStorage.setItem(COUNTDOWN_CACHE_KEY, Date.now().toString())
    countdown(COUNT_DOWN_DEFAULT_SECOND)
    ElMessage.success(t('login.verifyCodeSent'))
  })
}

async function handleEditName () {
  if (nameIsEdit.value) {
    return
  }

  nameIsEdit.value = true
  await nextTick()
  nameEditRefNode.value.focus()
}

function handleCancelUnbindPhone () {
  activeName.value = ACTIVE_NAME_MAP.default
}

function handleShowUnbindPhone () {
  activeName.value = ACTIVE_NAME_MAP.ubindPhone
}

function handleShowbindPhoneConfirm () {
  activeName.value = ACTIVE_NAME_MAP.bindPhone
  nextTick(() => {
    // checkPullVerifyCodeState()
    recoveryCountdown()
  })
}

function handlerNicknameChange () {
  // 回车保存导致输入框卸载后可能再次触发 blur，此时直接忽略
  if (!nameIsEdit.value) {
    return
  }
  const name = userInfo.nick.trim()
  if (!name) {
    // 昵称被清空：恢复服务端值并退出编辑（代替取消操作）
    fetchUserInfo()
    nameIsEdit.value = false
    return
  }
  if (name.length > USER_NAME_MAX_LENGTH) {
    ElMessage.warning(t('userInfoEdit.nicknameMaxLength', { max: USER_NAME_MAX_LENGTH }))
    nameEditRefNode.value?.focus()
    return
  }
  userInfoEditService.updateUserName(name).then(() => {
    user.updateUserinfo(userInfo as UserInfo)
  }).catch(error => {
    if (error.responseBody?.ret === errorKeyMap.ILLEGAL_PARAMETER.ret) {
      ElMessage.error(t('userInfoEdit.nicknameLengthExceeded'))
    } else {
      defaultErrorAction(error)
    }
  })
  nameIsEdit.value = false
}

function handlerBindPhone () {
  bindPhone()
}

function handlerUnbindPhone () {
  // TODO
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_el_footer = _resolveComponent("el-footer")!
  const _component_CmSvgIcon = _resolveComponent("CmSvgIcon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ([_unref(ACTIVE_NAME_MAP).bindPhone, _unref(ACTIVE_NAME_MAP).ubindPhone].includes(activeName.value))
      ? (_openBlock(), _createBlock(_component_el_container, {
          key: 0,
          class: "pane",
          direction: "vertical"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('userInfoEdit.smsVerifyTitle')), 1),
            _createVNode(_component_el_form, {
              model: tempForm,
              ref_key: "tempFormRef",
              ref: tempFormRef,
              rules: rules.value,
              "label-width": "0",
              class: "form"
            }, {
              default: _withCtx(() => [
                _createElementVNode("ul", _hoisted_2, [
                  _createElementVNode("li", null, [
                    _createVNode(_component_el_form_item, { prop: "phone" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          size: "small",
                          modelValue: tempForm.phone,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tempForm.phone) = $event)),
                          placeholder: _ctx.$t('common.phPhone'),
                          controls: false,
                          onInput: checkPullVerifyCodeState
                        }, null, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_el_form_item, { prop: "code" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_3, [
                          _createVNode(_component_el_input, {
                            size: "small",
                            class: "input-code",
                            modelValue: tempForm.code,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((tempForm.code) = $event)),
                            placeholder: _ctx.$t('common.phVerifyCode'),
                            clearable: ""
                          }, null, 8, ["modelValue", "placeholder"]),
                          _createVNode(_component_el_button, {
                            class: "btn-get-code",
                            size: "small",
                            onClick: getVerifyCode,
                            disabled: !canPullVerifyCode.value
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(verifyCodeText.value), 1)
                            ]),
                            _: 1
                          }, 8, ["disabled"])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", _hoisted_4, [
                    (activeName.value === _unref(ACTIVE_NAME_MAP).bindPhone)
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 0,
                          class: "btn-bind",
                          type: "primary",
                          size: "small",
                          onClick: handlerBindPhone
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('userInfoEdit.bindPhone')), 1)
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_el_button, {
                          key: 1,
                          size: "small",
                          class: "btn-bind",
                          type: "primary",
                          onClick: handlerUnbindPhone
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('userInfoEdit.confirmUnbindPhone')), 1)
                          ]),
                          _: 1
                        }))
                  ])
                ])
              ]),
              _: 1
            }, 8, ["model", "rules"])
          ]),
          _: 1
        }))
      : (activeName.value === _unref(ACTIVE_NAME_MAP).ubindPhoneConfirm)
        ? (_openBlock(), _createBlock(_component_el_container, {
            key: 1,
            class: "pane",
            direction: "vertical"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('userInfoEdit.unbindPhoneTitle')), 1),
              _createVNode(_component_el_container, { class: "unbind-confirm" }, {
                default: _withCtx(() => [
                  _hoisted_6,
                  _createElementVNode("ul", null, [
                    _createElementVNode("li", null, _toDisplayString(_ctx.$t('userInfoEdit.unbindPhoneIntro', { phone: userInfoSpec.mobile })), 1),
                    _createElementVNode("li", null, _toDisplayString(_ctx.$t('userInfoEdit.unbindPhoneAskContinue')), 1)
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_footer, {
                class: "ft cm-ui-txt-rgt",
                height: "auto"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    class: "btn",
                    size: "small",
                    onClick: handleCancelUnbindPhone
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_button, {
                    class: "btn",
                    size: "small",
                    type: "primary",
                    onClick: handleShowUnbindPhone
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('userInfoEdit.unbindPhoneConfirm')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('centralControl.personalInfo')), 1),
            _createElementVNode("header", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  (nameIsEdit.value)
                    ? (_openBlock(), _createBlock(_component_el_input, {
                        key: 0,
                        ref_key: "nameEditRefNode",
                        ref: nameEditRefNode,
                        class: "id-head__name-input",
                        size: "small",
                        modelValue: userInfo.nick,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((userInfo.nick) = $event)),
                        onKeyup: _withKeys(handlerNicknameChange, ["enter"]),
                        onBlur: handlerNicknameChange
                      }, null, 8, ["modelValue"]))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createElementVNode("strong", {
                          class: "id-head__name",
                          title: userInfo.nick,
                          onClick: handleEditName
                        }, _toDisplayString(userInfo.nick), 9, _hoisted_13),
                        _createElementVNode("button", {
                          class: "id-head__edit",
                          type: "button",
                          "aria-label": _ctx.$t('common.edit'),
                          onClick: handleEditName
                        }, [
                          _createVNode(_component_CmSvgIcon, {
                            name: "views/dashboard/_components/central-control/_components/user-info-edit/_images/edit",
                            monochrome: "",
                            size: 18
                          })
                        ], 8, _hoisted_14)
                      ], 64))
                ]),
                (accountTypeLabel.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(accountTypeLabel.value), 1))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_component_CmSvgIcon, {
                class: "id-head__watermark",
                name: "views/dashboard/_components/central-control/_components/user-info-edit/_images/person",
                monochrome: "",
                size: 108,
                "aria-hidden": "true"
              })
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("span", _hoisted_17, [
                _createVNode(_component_CmSvgIcon, {
                  name: "views/dashboard/_components/central-control/_components/user-info-edit/_images/account",
                  monochrome: "",
                  size: 18
                }),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('userInfoEdit.accountId')), 1)
              ]),
              _createVNode(Copy, { class: "id-strip__value" }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(userInfo.uid), 1)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("dl", _hoisted_18, [
              (!userInfoSpec.is_account_user)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _createElementVNode("dt", _hoisted_20, [
                      _createVNode(_component_CmSvgIcon, {
                        name: "views/dashboard/_components/central-control/_components/user-info-edit/_images/phone",
                        monochrome: "",
                        size: 18
                      }),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('userInfoEdit.mobile')), 1)
                    ]),
                    _createElementVNode("dd", _hoisted_21, [
                      (userInfoSpec.mobile)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(maskedMobile.value), 1))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t('userInfoEdit.dash')), 1),
                            _createElementVNode("span", {
                              class: "cm-link",
                              onClick: handleShowbindPhoneConfirm
                            }, [
                              _createVNode(_component_CmSvgIcon, {
                                name: "views/dashboard/_components/central-control/_components/user-info-edit/_images/link",
                                monochrome: "",
                                size: 18
                              })
                            ])
                          ], 64))
                    ])
                  ]))
                : _createCommentVNode("", true),
              (userInfoSpec.is_account_user)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    _createElementVNode("dt", _hoisted_24, [
                      _createVNode(_component_CmSvgIcon, {
                        name: "views/dashboard/_components/central-control/_components/user-info-edit/_images/type",
                        monochrome: "",
                        size: 18
                      }),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('userInfoEdit.account')), 1)
                    ]),
                    _createElementVNode("dd", _hoisted_25, _toDisplayString(userInfoSpec.user_name), 1)
                  ]))
                : _createCommentVNode("", true),
              (userInfoSpec.is_account_user)
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                    _createElementVNode("dt", _hoisted_27, [
                      _createVNode(_component_CmSvgIcon, {
                        name: "views/dashboard/_components/central-control/_components/user-info-edit/_images/password",
                        monochrome: "",
                        size: 18
                      }),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('userInfoEdit.password')), 1)
                    ]),
                    _createElementVNode("dd", _hoisted_28, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "text-button",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (updatePasswordVisible.value = true))
                      }, _toDisplayString(_ctx.$t('centralControl.changePassword')), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("dt", _hoisted_30, [
                  _createVNode(_component_CmSvgIcon, {
                    name: "views/dashboard/_components/central-control/_components/user-info-edit/_images/setting",
                    monochrome: "",
                    size: 18
                  }),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('userInfoEdit.operation')), 1)
                ]),
                _createElementVNode("dd", _hoisted_31, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "text-button text-button--danger",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (deleteUserVisible.value = true))
                  }, _toDisplayString(_ctx.$t('userInfoEdit.deregisterAccount')), 1)
                ])
              ])
            ])
          ])),
    _createVNode(DeleteUser, {
      modelValue: deleteUserVisible.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((deleteUserVisible).value = $event))
    }, null, 8, ["modelValue"]),
    _createVNode(UpdatePassword, {
      modelValue: updatePasswordVisible.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((updatePasswordVisible).value = $event))
    }, null, 8, ["modelValue"])
  ], 64))
}
}

})